import React from "react";
import Button from "../Button";
import {BUTTON_COLORS} from '../Button/appearance';

export default function FooterButtonView({
  step,
  isSubmitting,
  selectedBiomarkers,
  onClose,
  onBack,
  onNext,
  status,
  onCancelRequest
}) {
  if (!status) {
    return (
      <div className={`d-flex ${step > 1 ? "justify-content-between" : "justify-content-end"} w-100`}>
        {step > 1 && (
          <Button
            color={BUTTON_COLORS.primaryOutline}
            onClick={onBack}
            disabled={isSubmitting}
          >
            Back
          </Button>
        )}
        <section>
          <Button
            color={BUTTON_COLORS.primaryOutline}
            onClick={() => onClose(null)}
            disabled={isSubmitting}
            className="me-2">
            Close
          </Button>
          <Button
            color={BUTTON_COLORS.primary}
            onClick={onNext}
            disabled={(step === 2 && selectedBiomarkers.length === 0) || isSubmitting}
          >
            {isSubmitting ? "Submitting..." : step < 3 ? "Next" : "Create Retest"}
          </Button>
        </section>
      </div>
    );
  } else if (status === "pending") {
    return (
      <div className="d-flex justify-content-between w-100">
        <Button
          color={BUTTON_COLORS.primaryOutline}
          onClick={onCancelRequest}
        >
          Cancel Retest
        </Button>
        <Button
          color={BUTTON_COLORS.primaryOutline}
          onClick={() => onClose(null)}>
          Close
        </Button>
      </div>
    );
  } else if (status === "activated") {
    return (
      <Button
        color={BUTTON_COLORS.primaryOutline}
        onClick={() => onClose(null)}
      >
        Close
      </Button>
    );
  } else {
    return (
      <div className="d-flex justify-content-end w-100">
        <Button
          color={BUTTON_COLORS.primaryOutline}
          onClick={() => onClose(null)}
          className="me-2">
          Close
        </Button>
        <Button
          color={BUTTON_COLORS.primary}
          onClick={onNext}
        >
          Create Retest
        </Button>
      </div>
    );
  }
}
